module.exports = __webpack_public_path__ + "static/media/play-white.c8b8af47.svg";